
import { INetwork } from "../../interfaces/iNetwork";
import { IMemberOrganisationCard } from "../../interfaces/iMemberOrganisationCard";

export class MemberProfileNetwork implements INetwork {
    companyMembers: IMemberOrganisationCard[];
    nonprofitMembers: IMemberOrganisationCard[];
    schoolMembers: IMemberOrganisationCard[];

    constructor(companyMembers: IMemberOrganisationCard[], nonprofitMembers: IMemberOrganisationCard[], schoolMembers: IMemberOrganisationCard[]) {
        this.companyMembers = companyMembers;
        this.nonprofitMembers = nonprofitMembers;
        this.schoolMembers = schoolMembers;
    }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/memberProfile/memberProfileNetwork.ts